import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CHAT_ESCALATION_ACTION_TYPE } from '../actions';

const initialState = [];

const chatEscalationReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case CHAT_ESCALATION_ACTION_TYPE.GET_LADDER:
      case CHAT_ESCALATION_ACTION_TYPE.SAVE_LADDER:
        return payload || initialState;

      case CHAT_ESCALATION_ACTION_TYPE.DELETE_LADDER:
      case CHAT_ESCALATION_ACTION_TYPE.RESET_STATE:
      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default chatEscalationReducer;
